import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';
import headerImage from "../../media/images/nice_view.jpeg";

const Hero = styled.section`
    position: relative;
    height: 100vh;
    display: grid;
    place-items: center;
    text-align: center;
    color: #fff;
    background: url(${headerImage}) top/cover no-repeat fixed;

    &:before {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, .45), rgba(0, 0, 0, .35));
    }
`;

const HeroContent = styled.div`
    position: relative;
    z-index: 1;
    padding: 0 16px;
    max-width: 980px;
`;

const HeroTitle = styled(motion.h1)`
    font-size: clamp(2rem, 4vw, 3.25rem);
    margin: 0;
    text-shadow: 0 10px 30px rgba(0, 0, 0, 0.45);
`;

const HeroSubtitle = styled(motion.p)`
    font-size: clamp(1.05rem, 2vw, 1.35rem);
    margin: 14px 0 24px;
    opacity: .95;
`;

const CtaButton = styled(motion.a)`
    display: inline-block;
    padding: 14px 22px;
    border-radius: 12px;
    font-weight: 700;
    background: #c58e50;
    color: #fff;
    box-shadow: 0 8px 20px rgba(197, 142, 80, 0.3);
    transition: background 0.3s ease;

    &:hover {
        background: #a6743f;
    }
`;

const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export default function HeroSection() {
    return (
        <Hero id="home">
            <HeroContent>
                <HeroTitle variants={fadeInUp} initial="hidden" animate="visible">
                    EPDM решения за плоски покриви
                </HeroTitle>
                <HeroSubtitle variants={fadeInUp} initial="hidden" animate="visible" transition={{delay: .15}}>
                    Надеждни хидроизолационни системи за дълготрайна защита – проектирани специално за плоски покриви.
                </HeroSubtitle>
                <CtaButton href="#epdm" variants={fadeInUp} initial="hidden" animate="visible" transition={{delay: .3}}>
                    Научи повече
                </CtaButton>
            </HeroContent>
        </Hero>

    );
}
